import React from "react";
import {Router, Route, Switch} from "react-router-dom";

import Loading from "./components/Loading";
import Home from "./views/Home";
import Activity from "./views/Activity";
import Search from "./views/Search";
import Profile from "./views/Profile";
import {useAuth0} from "@auth0/auth0-react";
import history from "./utils/history";

// styles
import "./styles/styles.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";

initFontAwesome();

const App = () => {
    const {isLoading, error, isAuthenticated} = useAuth0();

    if (error) {
        return <div>Oops... {error.message}</div>;
    }

    if (isLoading) {
        return <Loading/>;
    }

    return (
        <Router history={history}>
            <div id="app" className="d-flex flex-column h-100">
                <Switch>
                    <Route path="/" exact component={(isAuthenticated) ? Activity : Home}/>
                    <Route path="/search" component={Search}/>
                    <Route path="/profile" component={Profile}/>
                </Switch>
            </div>
        </Router>
    );
};

export default App;
